var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3"},[_c('pricing-table',{ref:"devicesTable",attrs:{"search":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }